import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import { getExactResolutions } from '../../../utils/webp';

import {
  Container,
  Content,
  Title,
  ReadMoreLink,
  ReadMoreHref,
} from '../styles/carousel-article.style';

const defaultProps = {
  data: {
    image: {
      file: {
        url: '',
        details: {
          image: {
            width: 0,
            height: 0,
          },
        },
      },
      resolutions: {
        base64: '',
      },
    },
    description: {
      childMarkdownRemark: {},
    },
    videoId: null,
  },
};

const propTypes = {
  data: PropTypes.object,
};

/**
 * Left Aligned Promo Component
 * @param {object} props Incoming Props
 * @returns {XML} A Left Aligned Promo Component
 */
class Article extends React.Component {
  /**
   * constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.ref = this.ref.bind(this);
    this.state = {
      width: 400,
    };
  }

  /**
   * Get rect
   * @param {object} element DOM reference
   */
  ref(element) {
    if (element && element.getBoundingClientRect()) {
      this.setState({ width: element.getBoundingClientRect().width });
    }
  }

  /**
   * Render component
   * @returns {JSX} Component JSX
   */
  render() {
    const {
      data,
    } = this.props;
    const { width } = this.state;
    const optimizedResolutions = getExactResolutions({
      image: data.image || {},
      width: Math.floor(Math.min(width, 1140)),
      height: 250,
    });
    return (
      <Container className="article-card">
        <div className="media" ref={this.ref}>
          {data.externalUrl ? (
            <a href={data.externalUrl} target="_blank" rel="noopener noreferrer">
              <Img resolutions={optimizedResolutions} alt="" />
            </a>
          ) : (
            <Link to={`/articles/${data.articleSlug}`}>
              <Img resolutions={optimizedResolutions} alt="" />
            </Link>
          )}
        </div>
        <Content>
          <Title>{data.title}</Title>
          {data.source ? (
            <div className="source">{data.source}</div>
          ) : ''}
          {data.externalUrl ? (
            <ReadMoreHref href={data.externalUrl} target="_blank">
              <span>Read More</span>
            </ReadMoreHref>
          ) : (
            <ReadMoreLink to={`/articles/${data.articleSlug}`}>
              <span>Read More</span>
            </ReadMoreLink>
          )}
        </Content>
      </Container>
    );
  }
}

Article.defaultProps = defaultProps;
Article.propTypes = propTypes;

export default Article;



// WEBPACK FOOTER //
// ./src/components/carousel/components/carousel-article.js